export function cloneTemplate(id) {
    const tpl = document.getElementById(id);
    if (!tpl?.content?.firstElementChild) {
        throw new Error(`Missing DOM template #${id}`);
    }
    return $(tpl.content.firstElementChild.cloneNode(true));
}

export function setTableRowValues($row, values) {
    $row.find('td').each(function (index) {
        if (index < values.length) {
            $(this).text(values[index] == null ? '' : String(values[index]));
        }
    });
}
